import styled from 'styled-components';

import { SkeletonHeadline, SkeletonBodyCopy } from '@xing-com/skeleton';
import { space3XL, spaceL, spaceXXL } from '@xing-com/tokens';

const AuthorFollowersSkeleton = styled.div`
  display: flex;
  flex-direction: column;
`;

const AuthorFollowersHeadlineSkeleton = styled(SkeletonHeadline)`
  margin-bottom: ${spaceXXL};
  width: 90%;
`;

const AuthorFollowersEntryContainerSkeleton = styled.div`
  display: flex;
  gap: ${spaceL};
  margin-bottom: ${space3XL};
`;

const AuthorFollowersEntryInfoSkeleton = styled(SkeletonBodyCopy)`
  flex: 0.75;
`;

export const Styled = {
  AuthorFollowersSkeleton,
  AuthorFollowersHeadlineSkeleton,
  AuthorFollowersEntryContainerSkeleton,
  AuthorFollowersEntryInfoSkeleton,
};
